// extracted by mini-css-extract-plugin
export default {"tool":"cardprerequisite_tool__Hr5Qr","picto":"cardprerequisite_picto__eKehL"};